export const IMPORT_COMMUNICATOR = 'cboard/Communicator/IMPORT_COMMUNICATOR';
export const CREATE_COMMUNICATOR = 'cboard/Communicator/CREATE_COMMUNICATOR';
export const EDIT_COMMUNICATOR = 'cboard/Communicator/EDIT_COMMUNICATOR';
export const DELETE_COMMUNICATOR = 'cboard/Communicator/DELETE_COMMUNICATOR';
export const CHANGE_COMMUNICATOR = 'cboard/Communicator/CHANGE_COMMUNICATOR';
export const ADD_BOARD_COMMUNICATOR =
  'cboard/Communicator/ADD_BOARD_COMMUNICATOR';
export const DELETE_BOARD_COMMUNICATOR =
  'cboard/Communicator/DELETE_BOARD_COMMUNICATOR';
export const REPLACE_BOARD_COMMUNICATOR =
  'cboard/Communicator/REPLACE_BOARD_COMMUNICATOR';
export const ADD_DEFAULT_BOARD_INCLUDED =
  'cboard/Communicator/ADD_DEFAULT_BOARD_INCLUDED';
export const UPDATE_DEFAULT_BOARDS_INCLUDED =
  'cboard/Communicator/UPDATE_DEFAULT_BOARDS_INCLUDED';
export const CREATE_API_COMMUNICATOR_SUCCESS =
  'cboard/Communicator/CREATE_API_COMMUNICATOR_SUCCESS';
export const CREATE_API_COMMUNICATOR_FAILURE =
  'cboard/Communicator/CREATE_API_COMMUNICATOR_FAILURE';
export const CREATE_API_COMMUNICATOR_STARTED =
  'cboard/Communicator/CREATE_API_COMMUNICATOR_STARTED';
export const UPDATE_API_COMMUNICATOR_SUCCESS =
  'cboard/Communicator/UPDATE_API_COMMUNICATOR_SUCCESS';
export const UPDATE_API_COMMUNICATOR_FAILURE =
  'cboard/Communicator/UPDATE_API_COMMUNICATOR_FAILURE';
export const UPDATE_API_COMMUNICATOR_STARTED =
  'cboard/Communicator/UPDATE_API_COMMUNICATOR_STARTED';
export const GET_API_MY_COMMUNICATORS_SUCCESS =
  'cboard/Communicator/GET_API_MY_COMMUNICATORS_SUCCESS';
export const GET_API_MY_COMMUNICATORS_FAILURE =
  'cboard/Communicator/GET_API_MY_COMMUNICATORS_FAILURE';
export const GET_API_MY_COMMUNICATORS_STARTED =
  'cboard/Communicator/GET_API_MY_COMMUNICATORS_STARTED';
export const SYNC_COMMUNICATORS = 'Communicator/SYNC_COMMUNICATORS';
